export const transformStringWithUnderScores = (path: string): string => {
  return path.includes('_') ? path.replace(/_/g, '-') : path;
};
